module.exports = __webpack_public_path__ + "media/images/ico-circle-plus-b40c3721.svg";